module.exports = __webpack_public_path__ + "img/156.555611c4.jpg";